import React, { FC, useEffect } from "react";
import {
  IVisitStages,
  PortalStatusOption,
  StatusOption,
} from "../../../../interfaces/IPreAuth";
import { IFetchAllDetails } from "../../../../interfaces/IPatient";
import ManualPortalStatus from "../ManualPortalStatusButton";
import ManualStatus from "../ManualStatusButton";
import { Col, DatePicker, Form, Input, Row, Tooltip } from "antd";
import { Button } from "antd";
import dayjs from "dayjs";
import {
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  EditOutlined,
} from "@ant-design/icons";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../../../utils/notificationUtils";

type RegistrationAyushBProps = {
  currentActiveStage: IVisitStages;
  patientStore: IFetchAllDetails | null;
  stageAllState: {
    [key: string]: StatusOption[];
  } | null;
  currentStageDetails: IVisitStages | null;
  setManualStatusUpdateCount: CallableFunction;
  schemePortalStatusList: PortalStatusOption[] | null;
  portalData: any;
  nextStage: any;
  setMoveToNext: CallableFunction;
  claimId: string | null;
  editRegId: boolean;
  stageStatus: number | null;
  isEditable: boolean;
  handleEditRegId: any;
  handleSubmitId: any;
  handleRegistration: CallableFunction;
  form: any;
};

const RegistrationAyushB: FC<RegistrationAyushBProps> = (props) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  const styles = {
    mainContent: {
      gap: "15px",
      borderRadius: "16px",
      margin: "0px 0.5rem",
    },
    borderDesign: {
      minHeight: "64px",
      background: "rgb(243, 243, 243)",
      padding: "12px 35px",
      gap: "42px",
      borderRadius: "16px 16px 0px 0px",
      border: "1px solid rgb(87, 87, 87)",
      fontWeight: "600",
      fontSize: "16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    statusDesign: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "20px",
      minWidth: "676px",
      maxHeight: "36px",
    },
    bodyDesign: {
      borderRadius: "0px 0px 16px 16px",
      border: "1px solid rgb(87, 87, 87)",
      borderTop: 0,
      padding: "10px 20px",
    },
  };

  const customStatus =
    props?.currentActiveStage?.step && props?.currentStageDetails?.step
      ? props?.currentActiveStage.step === props?.currentStageDetails.step
        ? props?.currentStageDetails.stateId
        : props?.currentActiveStage.step > props?.currentStageDetails.step
        ? 8
        : 4
      : null;

  useEffect(() => {
    if (props?.patientStore) {
      props?.form.setFieldsValue({
        beneficiaryId:
          props?.portalData?.beneficiaryId ||
          props?.patientStore?.casesResponse?.memberId ||
          props?.patientStore?.referralInfoResponse?.cghsReferralResponse
            ?.beneficiaryId ||
          props?.patientStore?.visitInfoResponse?.opNumber,
        registrationDate: props?.portalData?.registrationDate
          ? dayjs(props?.portalData?.registrationDate, dateFormat)
          : props?.patientStore?.visitInfoResponse?.doa
          ? dayjs(props?.patientStore?.visitInfoResponse?.doa, dateFormat)
          : null,
        registrationId: props?.portalData?.schemeRegistrationId,
      });
    }
  }, [props?.patientStore, props?.portalData]);

  const handleUpdateId = async () => {
    try {
      const values = await props?.form.validateFields();
      await props?.handleSubmitId(values);
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please fill all details before submitting");
      } else {
        errorMessage(err?.response?.data || "Please, Try again after sometime");
      }
    }
  };

  const handleSubmit = async () => {
    await props?.handleRegistration();
  };
  
  return (
    <div style={styles.mainContent}>
      <div style={styles.borderDesign}>
        <span style={{ fontSize: "20px", alignContent: "center" }}>
          REGISTRATION
        </span>
        <div style={styles.statusDesign}>
          {props?.currentActiveStage?.visitStageId &&
            props?.patientStore?.visitInfoResponse?.id && (
              <ManualStatus
                stateData={
                  props?.stageAllState?.[
                    props?.currentActiveStage?.visitStageId
                  ] || null
                }
                status={props?.stageStatus}
                visitId={props?.patientStore?.visitInfoResponse?.id}
                visitStageId={props?.currentActiveStage?.visitStageId}
                isUpdateable={props?.isEditable}
                // setManualStatusUpdateCount={props?.setManualStatusUpdateCount}
              />
            )}
          {(props?.patientStore?.visitInfoResponse?.portalStatus ||
            props?.patientStore?.visitInfoResponse?.id) && (
            <ManualPortalStatus
              // statusList={props?.schemePortalStatusList || []}
              status={props?.portalData?.portalStatus || "-"}
              visitId={props?.patientStore?.visitInfoResponse?.id}
              isUpdateable={props?.isEditable}
              // setManualStatusUpdateCount={props?.setManualStatusUpdateCount}
            />
          )}
        </div>
      </div>
      <div className="registration-body" style={styles.bodyDesign}>
        <Form
          form={props?.form}
          onFinish={handleSubmit}
          labelAlign="left"
          layout="vertical"
          labelWrap
          style={{ width: "100%" }}
        >
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={7} lg={7} xl={7}>
              <Form.Item
                label="BENEFICIARY ID"
                name="beneficiaryId"
                style={{ marginTop: "1.7rem" }}
                rules={[
                  {
                    required: true,
                    message: "Please input BENEFICIARY ID",
                  },
                ]}
              >
                <Input
                  placeholder="Please input BENEFICIARY ID"
                  disabled
                  style={{ color: "black" }}
                />
              </Form.Item>
            </Col>

            {props?.portalData?.schemeRegistrationId ? (
              !props?.editRegId ? (
                <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                  <Form.Item
                    label="REGISTRATION ID"
                    name="registrationId"
                    style={{ marginTop: "1.7rem", color: "black" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input REGISTRATION ID",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Please input REGISTRATION ID"
                      disabled={props?.portalData?.schemeRegistrationId}
                      style={{ color: "black" }}
                    />
                  </Form.Item>
                </Col>
              ) : (
                <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                  <Form.Item
                    label="REGISTRATION ID"
                    name="registrationId"
                    style={{ marginTop: "1.7rem", color: "black" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input REGISTRATION ID",
                      },
                      {
                        pattern: /^\S+$/,
                        message: "REGISTRATION ID must not contain spaces",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Please input REGISTRATION ID"
                      // disabled={props?.portalData?.schemeRegistrationId}
                      style={{ color: "black" }}
                    />
                  </Form.Item>
                </Col>
              )
            ) : (
              <>
                <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                  <Form.Item
                    label="REGISTRATION ID"
                    name="registrationId"
                    style={{ marginTop: "1.7rem", color: "black" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input REGISTRATION ID",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Please input REGISTRATION ID"
                      disabled={props?.portalData?.schemeRegistrationId}
                      style={{ color: "black" }}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
            { false && props?.portalData?.schemeRegistrationId ? (
              !props?.editRegId ? (
                <>
                  {/* Hidden input element for copying */}
                  <input
                    type="text"
                    id="hidden-copy-input"
                    value={props?.portalData?.schemeRegistrationId || ""}
                    readOnly
                    style={{ position: "absolute", left: "-9999px" }}
                  />

                  {/* Copy Icon */}
                  <Tooltip title="Copy Registration ID">
                    <CopyOutlined
                      style={{
                        paddingTop: "24px",
                        fontSize: "20px",
                        marginLeft: "8px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        const hiddenInput: any =
                          document.getElementById("hidden-copy-input");
                        if (hiddenInput) {
                          hiddenInput.select();

                          try {
                            const successful = document.execCommand("copy");
                            if (successful) {
                              successMessage(
                                "Registration ID copied to clipboard!"
                              );
                            } else {
                              errorMessage("Failed to copy Registration ID.");
                            }
                          } catch (err) {
                            errorMessage("Copy command failed!");
                          }
                        } else {
                          warningMessage("No Registration ID to copy!");
                        }
                      }}
                    />
                  </Tooltip>
                  {!props?.claimId ? (
                    <Tooltip title="Edit Registration ID">
                      <EditOutlined
                        style={{
                          paddingTop: "24px",
                          fontSize: "20px",
                          marginLeft: "8px",
                          cursor: "pointer",
                        }}
                        onClick={props?.handleEditRegId}
                      />
                    </Tooltip>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  <Tooltip title="Cancel Update Registration ID">
                    <CloseOutlined
                      style={{
                        paddingTop: "24px",
                        fontSize: "20px",
                        marginLeft: "8px",
                        cursor: "pointer",
                      }}
                      onClick={props?.handleEditRegId}
                    />
                  </Tooltip>
                  <Tooltip title="Save Registration ID">
                    <CheckOutlined
                      style={{
                        paddingTop: "24px",
                        fontSize: "20px",
                        marginLeft: "8px",
                        cursor: "pointer",
                      }}
                      onClick={handleUpdateId}
                    />
                  </Tooltip>
                </>
              )
            ) : (
              <></>
            )} 
          </Row>

          <div
            style={{
              marginTop: 20,
              display: "flex",
              justifyContent: "flex-end",
              gap: "30px",
              borderTop: "1px solid #D9D9D9",
              padding: "15px 20px",
            }}
          >
            {
              (!props?.portalData?.schemeRegistrationId) ?
                (<div style={{ width: "16%" }}>
                  <Form.Item wrapperCol={{ span: 16 }}>
                    {
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{
                          border: "1px solid darkcyan",
                          background: "darkcyan",
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "white",
                        }}
                      >
                        PORTAL REGISTRATION
                      </Button>
                    }
                  </Form.Item>
                </div>) :
                (props?.portalData?.schemeRegistrationId) && (<div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#008B8B",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    onClick={() => {
                      props?.setMoveToNext(true);
                    }}
                  >
                    NEXT: {props?.nextStage?.visitStage}
                  </Button>
                </div>)
            }
          </div>
        </Form>
      </div>
    </div>
  );
};

export default RegistrationAyushB;
